<section class="sidebar-section" [class.no-username]="!usernameImage && !userName"
  [ngStyle]="{ 'justify-content': justifyContent() }">
  <div class="sidebar-section-main-image">
    <img [src]="logoSrc()" alt="" />
    @if (secondLogoSrc()) {
    <div class="sidebar-section-developed-by">
      <span class="text">Developed by</span>
      <img [src]="secondLogoSrc()" alt="Qeema Logo" />
    </div>
    }
  </div>
  <div class="sidebar-section-links">
    <ul>
      @for (link of sidebarLinks(); track link.id) {
      <li>
        <a *ngIf="!isExternal(link.url); else externalTpl" [routerLink]="link.url" routerLinkActive="activeLink"
          [routerLinkActiveOptions]="routerLinkActiveOptions()">
          <ng-container *ngIf="link.iconPath">
            <ng-container *ngComponentOutlet="link.iconPath"></ng-container>
          </ng-container>
          {{ link.name }}
        </a>

        <ng-template #externalTpl>
          <a [href]="link.url" target="_blank" rel="noopener noreferrer">
            <ng-container *ngIf="link.iconPath">
              <ng-container *ngComponentOutlet="link.iconPath"></ng-container>
            </ng-container>
            {{ link.name }}
          </a>
        </ng-template>
      </li>
      }
    </ul>
  </div>

  @if (usernameImage() && userName()) {
  <div class="sidebar-section-username">
    <div class="username-info">
      <div class="sidebar-section-username-image">
        <img [src]="usernameImage()" alt="" />
      </div>
      <div class="sidebar-section-username-name">
        <span>{{ userName() ? userName() : '' }}</span>
      </div>
    </div>
    @if(isAdmin()){
    <div class="edit-mode-switch-btn">
      <span>Edit Mode : </span>
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
          [(ngModel)]="editModeChecked" (change)="switchEditMode()" />
      </div>
    </div>
    }
    <div class="logout-btn" (click)="logout()">
      <i class="pi pi-sign-out"></i>
      logout
    </div>
  </div>
  }
</section>